// import React from "react";
// import { FaThumbsUp, FaRegCompass } from "react-icons/fa";
// import bg from "../../assets/mainbg2.jpg";
// import { Link } from "react-router-dom";

// const MembershipCard = () => {
//   return (
//     <div
//       className="relative max-w-5xl mx-auto rounded-2xl border overflow-hidden"
//       style={{
//         backgroundImage: `url(${bg})`,
//         backgroundSize: "cover",
//         backgroundPosition: "center",
//       }}
//     >
//       {/* Overlay to reduce background visibility */}
//       <div className="absolute inset-0 bg-black bg-opacity-50"></div>

//       {/* Content */}
//       <div className="relative z-10 p-6 md:p-12 flex flex-col md:flex-row items-center justify-between space-y-6 md:space-y-0 md:space-x-6">
//         {/* Left Content */}
//         <div className="flex-1 text-white">
//           <h2 className="text-2xl font-bold">Become a paid member OF  ROYAL RAJPUT JIVANSATHI</h2>
//           <p className="text-lg mt-2">
//             Get up to <span className="text-yellow-300 font-bold">68% OFF</span>{" "}
//             on paid membership!
//           </p>

//           {/* Features */}
//           <ul className="mt-4 space-y-2">
//             <li className="flex items-center space-x-2">
//               <span className="text-yellow-400">
//                 <FaThumbsUp />
//               </span>
//               <span>Higher chances of response</span>
//             </li>
//             <li className="flex items-center space-x-2">
//               <span className="text-yellow-400">
//                 <FaRegCompass />
//               </span>
//               <span>View and match horoscopes</span>
//             </li>
//           </ul>

//           {/* Button */}
//           <Link
//             to="/membership-pricing"
//             className="mt-6 inline-block text-decoration-none
//              bg-orange-600 hover:bg-orange-700 text-white font-semibold px-6 py-2 rounded-full"
//           >
//             Membership Plans
//           </Link>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default MembershipCard;
import React from "react";
import { FaHandsHelping, FaOm } from "react-icons/fa";
import { GiLotus } from "react-icons/gi";
import bg from "../../assets/mainbg2.jpg";
import { Link } from "react-router-dom";

const MembershipCard = () => {
  return (
    <div
      className="relative w-full max-w-5xl mx-auto rounded-2xl border border-amber-200/40 overflow-hidden"
      style={{
        backgroundImage: `url(${bg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {/* Overlay - warm maroon/saffron tint instead of plain black */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#3b0a12]/85 via-[#5c1a1a]/75 to-[#7a3b12]/70"></div>

      {/* Decorative Om watermark, hidden on very small screens to avoid clutter */}
      <FaOm className="hidden sm:block absolute -right-4 -bottom-6 text-[120px] sm:text-[160px] text-amber-200/10 z-0" />

      {/* Content */}
      <div className="relative z-10 px-5 py-8 sm:px-8 sm:py-10 md:p-12 flex flex-col items-center text-center md:items-start md:text-left">
        <div className="flex items-center gap-2 mb-2">
          <GiLotus className="text-amber-300 text-xl sm:text-2xl" />
          <span className="uppercase tracking-wide text-xs sm:text-sm text-amber-200 font-medium">
            Jain Spiritual Matrimony
          </span>
        </div>

        <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-white leading-snug max-w-xl">
          Become a Member of{" "}
          <span className="text-amber-300">Jain var vadhu</span>
        </h2>

        <p className="text-base sm:text-lg mt-3 text-amber-50">
          Get up to <span className="text-yellow-300 font-bold">68% OFF</span>{" "}
          on your membership and find your spiritually aligned life partner.
        </p>

        {/* Features */}
        <ul className="mt-5 space-y-3 text-sm sm:text-base text-white w-full max-w-md">
          <li className="flex items-center gap-3 justify-center md:justify-start">
            <span className="flex-shrink-0 bg-amber-300/20 text-amber-300 p-2 rounded-full">
              <FaHandsHelping />
            </span>
            <span>Higher chances of a meaningful response</span>
          </li>
          <li className="flex items-center gap-3 justify-center md:justify-start">
            <span className="flex-shrink-0 bg-amber-300/20 text-amber-300 p-2 rounded-full">
              <GiLotus />
            </span>
            <span>Match horoscopes &amp; Jain values together</span>
          </li>
        </ul>

        {/* Button */}
        <Link
          to="/membership-pricing"
          className="mt-6 inline-block no-underline bg-gradient-to-r from-amber-500 to-orange-600 hover:from-amber-600 hover:to-orange-700 text-white font-semibold px-6 py-2.5 sm:px-8 sm:py-3 rounded-full text-sm sm:text-base transition-colors"
        >
          View Membership Plans
        </Link>
      </div>
    </div>
  );
};

export default MembershipCard;
